import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_abschluss = _resolveComponent("abschluss")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      items: _ctx.navItems,
      active: 3,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createVNode(_component_abschluss, {
      produkt: "bh",
      "zeige-versichertes-objekt": true,
      "zeige-tarif": false,
      "zeige-objekt-anschrift": true,
      "zeige-selbstbeteiligung": false,
      "zeige-anzahl-vorschaeden": true,
      "zeige-eigentumsverhaeltnisse": true,
      onNextPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next-page', $event))),
      onGotoPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, _createSlots({
      "versichertes-objekt": _withCtx(() => [
        _createElementVNode("strong", null, [
          _createTextVNode(_toDisplayString(_ctx.artDesBauvorhabens) + ", Bausumme " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.gebaeudedaten.bausumme)) + " ", 1),
          (_ctx.gt(_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag, 0))
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, " , Eigenbauleistung: " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.gebaeudedaten.eigenbauleistungen.betrag)), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_ctx.piniaStore.state.isMakler)
        ? {
            name: "angaben-bestaetigen",
            fn: _withCtx(() => [
              _cache[3] || (_cache[3] = _createTextVNode(" Ja, der Antrag wurde gemäß meinen Angaben erstellt. Der/die Versicherungsmakler/in bestätigt stellvertretend im Auftrage seines Mandanten, dass mein Haus/meine Wohnung ständig bewohnt ist und dass die tariflichen Mindestsicherungen erfüllt sind. "))
            ]),
            key: "0"
          }
        : {
            name: "angaben-bestaetigen",
            fn: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" Ja, der Antrag wurde gemäß meinen Angaben erstellt. Die Baumaßnahme ist aus dem privaten Wohnungsbaubereich. Der gewerblich genutzte Anteil beträgt maximal 49%. Auf eine Beratung habe ich verzichtet und damit auf den Schadenersatzanspruch nach § 6 Abs. 5VVG. "))
            ]),
            key: "1"
          }
    ]), 1024)
  ], 64))
}